import React from 'react';
import PropTypes from 'prop-types';
import { useClassName, useWindowSize } from 'common/hooks';
import useCustomStyle from '../../hooks';
// import Section from '../../Section'; // Circular dependency fixed by using prop

import './grid.less';

export default function Grid({
  component,
  rawSection,
  refs,
  index,
  SectionComponent,
}) {
  const classNames = useClassName('clp-grid');
  const [setRef, style] = useCustomStyle(component.fields.settings);
  const viewport = useWindowSize();

  const columns = style['--columns'] || '1fr';
  const gap = style['--gap'] || '20px';
  const sections = component.fields.sections || [];
  // Get raw sections if available, assuming structure matches
  const rawSections = rawSection?.fields?.sections?.['en-US'] || [];

  const getLayout = (settings) => {
    if (!settings) return {};
    const layout = {};

    // Find responsive or default value for grid-column
    const gridColumnSetting = settings.find(
      (s) => s.fields.key === '--grid-column'
    );
    if (gridColumnSetting) {
      const { fields } = gridColumnSetting;
      const value =
        (viewport.isMobile && fields.mobileValue) ||
        (viewport.isTablet && fields.tabletValue) ||
        (viewport.isDesktop && fields.desktopValue) ||
        fields.value;
      if (value) layout.gridColumn = value;
    }

    // Find responsive or default value for grid-row
    const gridRowSetting = settings.find((s) => s.fields.key === '--grid-row');
    if (gridRowSetting) {
      const { fields } = gridRowSetting;
      const value =
        (viewport.isMobile && fields.mobileValue) ||
        (viewport.isTablet && fields.tabletValue) ||
        (viewport.isDesktop && fields.desktopValue) ||
        fields.value;
      if (value) layout.gridRow = value;
    }

    return layout;
  };

  return (
    <div
      ref={setRef}
      className={classNames('container')}
      style={{
        ...style,
        gridTemplateColumns: columns,
        gap: gap,
      }}>
      {sections.map((section, idx) => (
        <div
          key={idx}
          className={classNames('column')}
          style={getLayout(section.fields.settings)}>
          {SectionComponent ? (
            <SectionComponent
              section={section}
              rawSection={rawSections[idx]} // Pass raw section if needed mainly for forms
              refs={refs}
              index={`${index}-${idx}`} // Create unique index for nested refs
            />
          ) : null}
        </div>
      ))}
    </div>
  );
}

Grid.propTypes = {
  component: PropTypes.object.isRequired,
  rawSection: PropTypes.object,
  refs: PropTypes.object,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Grid.defaultProps = {
  refs: {},
};
